import { render, staticRenderFns } from "./ScaleQuestion.vue?vue&type=template&id=5742681e&scoped=true"
import script from "./ScaleQuestion.vue?vue&type=script&lang=ts"
export * from "./ScaleQuestion.vue?vue&type=script&lang=ts"
import style0 from "./ScaleQuestion.vue?vue&type=style&index=0&id=5742681e&prod&lang=scss&scoped=scoped"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5742681e",
  null
  
)

export default component.exports